import { FacebookAccount, FacebookAccountHighLevelPermissionType } from 'shared/interfaces/FacebookAccount';
import { InstagramAccount, InstagramAccountHighLevelPermissionType } from 'shared/interfaces/InstagramAccount';
import { SmartAssistant, UpdateSmartAssistantIntegrationsDto } from 'shared/interfaces/SmartAssistant';
import { WhatsAppAccount } from 'shared/interfaces/WhatsAppAccount';
import { axiosBaseInstance } from 'shared/utils/axios-instances';

const integrationManagerEndpoint = '/integration-manager';

export const IntegrationManagerService = {
  /**
   * Updates the integrations of a smart assistant.
   * Note that this overwrites the whole integration object, it does not merge it with the existing one.
   * For example, if you want to update the voice integration, you need to pass the whole new voice
   * integration object, not just the changes.
   */
  updateSmartAssistantIntegrations: async (
    updateSmartAssistantIntegrationsDto: UpdateSmartAssistantIntegrationsDto
  ): Promise<SmartAssistant> => {
    const response = await axiosBaseInstance({
      method: 'put',
      url: `${integrationManagerEndpoint}`,
      data: updateSmartAssistantIntegrationsDto
    });

    return response.data;
  },

  toggleShopifyWebsiteIntegration: async (smartAssistantId: string): Promise<SmartAssistant> => {
    const response = await axiosBaseInstance({
      method: 'post',
      url: `${integrationManagerEndpoint}/toggle-shopify`,
      data: {
        smartAssistantId
      }
    });

    return response.data;
  },

  getAvailableWhatsAppAccounts: async (smartAssistantId?: string): Promise<WhatsAppAccount[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${integrationManagerEndpoint}/whats-app-available`,
      params: {
        id: smartAssistantId
      }
    });

    return response.data;
  },

  getAvailableFacebookAccounts: async (
    smartAssistantId?: string,
    highLevelPermissionType?: FacebookAccountHighLevelPermissionType
  ): Promise<FacebookAccount[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${integrationManagerEndpoint}/facebook-available`,
      params: {
        smartAssistantId,
        highLevelPermissionType
      }
    });

    return response.data;
  },

  getAvailableInstagramAccounts: async (
    smartAssistantId?: string,
    highLevelPermissionType?: InstagramAccountHighLevelPermissionType
  ): Promise<InstagramAccount[]> => {
    const response = await axiosBaseInstance({
      method: 'get',
      url: `${integrationManagerEndpoint}/instagram-available`,
      params: {
        smartAssistantId,
        highLevelPermissionType
      }
    });

    return response.data;
  }
};
